import { ReactElement, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { ProjectGoalsAndMeasures } from 'src/screens/shared/project/details/goals-and-measures/ProjectGoalsAndMeasures'
import { queryProjectGoalsAndMeasuresByProcessAndProjectId } from 'src/screens/shared/project/details/goals-and-measures/projectGoalsAndMeasuresQueries'
import { useNotificationService } from 'src/shared/utils/NotificationService'
import { useClient } from 'urql'
import { Project_Goal, Project_Measure } from 'src/@types/graphql'

export const PfPgvGoalsAndMeasuresPage = (): ReactElement => {
  const { projectId } = useParams()
  const urqlClient = useClient()
  const notificationService = useNotificationService()
  const pf_pgv_id = parseInt(projectId as string)

  const [projectMeasures, setProjectMeasures] = useState<Array<Project_Measure>>([])
  const [projectGoals, setProjectGoals] = useState<Array<Project_Goal>>([])

  useEffect(() => {
    fetchGoalsAndMeasure().then((data) => {
      setProjectMeasures(data.measure)
      setProjectGoals(data.goals)
    })
  }, [])

  const fetchGoalsAndMeasure = async () => {
    const { data, error } = await urqlClient
      .query(queryProjectGoalsAndMeasuresByProcessAndProjectId, {
        projectBaseWhere: { pf_pgv_projects: { id: { _eq: pf_pgv_id } } },
        shouldFetchGoalFeatures: true,
      })
      .toPromise()

    if (error) {
      notificationService.operationFailed()
    } else if (data !== undefined) {
      const pf_pgv_project_goals = data.project_base?.[0].project_goals ?? []
      const pf_pgv_project_measures = data.project_base?.[0].project_measures ?? []

      return { goals: pf_pgv_project_goals, measure: pf_pgv_project_measures }
    }

    return { goals: [], measure: [] }
  }

  const refetch = () => {
    fetchGoalsAndMeasure().then((data) => {
      setProjectMeasures(data.measure)
      setProjectGoals(data.goals)
    })
  }

  return (
    <ProjectGoalsAndMeasures
      projectId={pf_pgv_id}
      projectGoals={projectGoals}
      baseUrl="/pf-pgv"
      refetch={refetch}
      projectMeasures={projectMeasures}
      showGoalFeatures={true}
    />
  )
}
